import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import UI from '../../constants/UI'
import HEROES from '../../constants/HEROES'
import RACES from '../../constants/RACES'
import ITEMGROUPS from '../../constants/ITEMGROUPS'

import { addToRoster } from '../../redux/actions/game/roster.actions'
import { addInventoryItems } from '../../redux/actions/game/inventory.actions'
import { addToResources } from '../../redux/actions/game/resources.actions'

import rewardHelper from '../../utils/rewardHelper'
import itemHelper from '../../utils/itemHelper'

const { getRewardData } = rewardHelper
const { createItemBase, getItemData } = itemHelper

const RewardBox = (props) => {
    const {
        rewards, addItems, addResources, addUnits,
    } = props

    const rewardItems = rewards.map((rewardString) => {
        const rewardData = getRewardData(rewardString)
        const {
            ID, type, name: label, identifier, details,
        } = rewardData
        const reward = {}

        switch (type) {
            case 'resources': {
                addResources({ [identifier]: parseInt(details, 10) })
                reward.icon = UI.RESOURCES[identifier].icon
                reward.detail = `${details} ${label}`
                break
            }
            case 'roster': {
                const newHero = HEROES[details]
                addUnits([newHero])
                const { type: race, name, gender } = newHero
                reward.icon = RACES[race].avatar[gender]
                reward.detail = `${name} joins the team!`
                break
            }
            case 'inventory': {
                const newItemSelection = ITEMGROUPS[identifier][details]
                const newItem = newItemSelection[Math.floor(
                    Math.random() * newItemSelection.length
                )]
                addItems([newItem])
                const itemPreview = getItemData(createItemBase(newItem))
                const { icon, name } = itemPreview
                reward.icon = icon
                reward.detail = name
                break
            }
            default: {
                // nothing to do here.
            }
        }

        return { ID, ...reward }
    })

    return (
        <div className="rewards--listing">
            {rewardItems.map((item) => {
                const { ID, icon, detail } = item
                return (
                    <div className="reward__card" key={ID}>
                        <span className="reward__card--icon">{icon}</span>
                        <span className="reward__card--detail">{detail}</span>
                    </div>
                )
            })}
        </div>
    )
}

RewardBox.propTypes = {
    rewards: PropTypes.array.isRequired,
    addUnits: PropTypes.func.isRequired,
    addItems: PropTypes.func.isRequired,
    addResources: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
    addUnits: baseUnits => dispatch(addToRoster(baseUnits)),
    addItems: baseItems => dispatch(addInventoryItems(baseItems)),
    addResources: resources => dispatch(addToResources(resources)),
})

export default connect(
    null,
    mapDispatchToProps,
)(RewardBox)
